export const FETCH_PACKAGE_UPSALE_OPTIONS_ACTION_TYPE =
  'FETCH_PACKAGE_UPSALE_OPTIONS_ACTION_TYPE';
